module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_2.c0ffb5c2.jpg";